<template>
  <div id="question-edit-dialog" class="custom-modal">
    <div class="modal-body">
      <template v-if="dammyQuestion">
        <el-row :gutter="10">
          <el-col :span="8">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.label") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.defineQuestion") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input v-model="dammyQuestion.title" :class="{ 'error-input': getQuestionValidationOne.some(x => x.key == dammyQuestion.id + '-Title') }"></el-input>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-Title", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.placeholder") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.placeholderMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input v-model="dammyQuestion.placeholder" :class="{ 'error-input': getQuestionValidationOne.some(x => x.key == dammyQuestion.id + '-Placeholder') }"></el-input>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-Placeholder", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.hint") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.hintMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input v-model="dammyQuestion.hint"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 101">
          <el-col :span="8">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.dateFormat") }}</label>
              </div>
              <el-select v-model="dammyQuestion.dateFormat">
                <el-option v-for="item in getEnums.find(x => x.title == 'DateFormat').enums" :label="item.displayName.toUpperCase()" :key="item.key" :value="item.key"></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 14 || dammyQuestion.type == 202">
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.initialValue") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.initialValueMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.initialValue" :min="1" :max="2000"></el-input-number>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-Title", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.minValue") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.minValueMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.minValue" :min="1" :max="2000"></el-input-number>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-Placeholder", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.maxValue") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.maxValueMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.maxValue" :min="1" :max="2000"></el-input-number>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.step") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.stepMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.step" :min="1" :max="2000"></el-input-number>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 10 || dammyQuestion.type == 11 || dammyQuestion.type == 30">
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.textTransform") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.textTransformMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-select v-model="dammyQuestion.textTransform">
                <el-option v-for="(item, index) in getEnums.find(x => x.title == 'TextTransformType').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
              </el-select>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-Title", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.minCharAllowed") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.minCharAllowedMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.minLength" :min="1" :max="2000"></el-input-number>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-Placeholder", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.maxCharAllowed") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.maxCharAllowedMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.maxLength" :min="1" :max="2000"></el-input-number>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.minLineAllowed") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.minLineAllowedMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.rows" :min="1" :max="2000"></el-input-number>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-if="dammyQuestion.type == 500">
          <el-col :span="12">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.color") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.colorMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <div class="color-picker-container">
                <div class="color" v-for="(test, index) in colors" :key="index" :class="{ active: dammyQuestion.infoBlockColor == '#' + test ? true : false }" @click="dammyQuestion.infoBlockColor = '#' + test" :style="{ 'background-color': '#' + test }">
                  <i class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 1">
          <el-col :span="24">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.domainRestriction") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span v-html="$t('components.registerForm.questionEdit.domainRestrictionMsg')"></span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-select v-model="dammyQuestion.limitedCountryCodes" multiple filterable allow-create>
                <el-option v-for="(item, index) in dammyQuestion.limitedCountryCodes" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-limitedCountryCodes", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 2">
          <el-col :span="24">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.countryCodeRestriction") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span v-html="$t('components.registerForm.questionEdit.countryCodeRestrictionMsg')"></span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-select v-model="dammyQuestion.limitedCountryCodes" multiple filterable>
                <el-option v-for="(country, index) in countryList" :key="index" :label="country.name" :value="country.code"></el-option>
              </el-select>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-limitedCountryCodes", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 104 || dammyQuestion.type == 32">
          <el-col :span="6">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.maxFileSize") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span v-html="$t('components.registerForm.questionEdit.maxFileSizeMsg')"></span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <el-input-number v-model="dammyQuestion.maxFileSizeMb" :min="1" :max="5"></el-input-number>
              <span class="error">{{ $errorMessage(dammyQuestion.id + "-Placeholder", getQuestionValidationOne) }}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 16">
          <el-col :span="12">
            <el-checkbox v-model="dammyQuestion.addSearchbox">{{ $t("components.registerForm.questionEdit.addSearchBox") }}</el-checkbox>
            <el-checkbox v-model="dammyQuestion.allowMultipleSelections">{{ $t("components.registerForm.questionEdit.multipleSelection") }}</el-checkbox>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-3" v-if="dammyQuestion.type == 104 || dammyQuestion.type == 32">
          <el-col :span="24">
            <div class="registerform-input-container">
              <div class="custom-label">
                <label>{{ $t("components.registerForm.questionEdit.fileType") }}</label>
                <el-tooltip placement="top">
                  <div slot="content" class="custom-tooltip-content">
                    <span>{{ $t("components.registerForm.questionEdit.fileTypeMsg") }}</span>
                  </div>
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <div class="question-checkbox-container">
                <div class="question-checkbox-title">
                  <el-checkbox :indeterminate="isImageIndeterminate" v-model="imageAll" @change="handleCheckAllImage">{{ $t("components.registerForm.questionEdit.imageFiles") }}</el-checkbox>
                </div>
                <el-checkbox-group v-model="dammyQuestion.allowedExtensions" class="question-custom-checkbox-group">
                  <el-checkbox v-for="(item, index) in getEnums.find(x => x.title == 'ImageFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                </el-checkbox-group>
              </div>
              <template v-if="question.type == 104">
                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isTextIndeterminate" v-model="textAll" @change="handleCheckAllText">{{ $t("components.registerForm.questionEdit.textFiles") }}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="dammyQuestion.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find(x => x.title == 'TextFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isSpeadSheetTypeIndeterminate" v-model="spreadSheetAll" @change="handleCheckAllSpeadSheetType">{{ $t("components.registerForm.questionEdit.spreadsheetFiles") }}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="dammyQuestion.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find(x => x.title == 'SpeadSheetType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isPresentationTypeIndeterminate" v-model="presentationAll" @change="handleCheckAllPresentationType">{{ $t("components.registerForm.questionEdit.presentationFiles") }}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="dammyQuestion.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find(x => x.title == 'PresentationFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>

                <div class="question-checkbox-container">
                  <div class="question-checkbox-title">
                    <el-checkbox :indeterminate="isCompressedTypeIndeterminate" v-model="compressedAll" @change="handleCheckAllCompressedType">{{ $t("components.registerForm.questionEdit.compressedFiles") }}</el-checkbox>
                  </div>
                  <el-checkbox-group v-model="dammyQuestion.allowedExtensions" class="question-custom-checkbox-group">
                    <el-checkbox v-for="(item, index) in getEnums.find(x => x.title == 'CompressedFileType').enums" :key="index" :label="item.displayName"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </template>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-if="mainType == 0 && mainType != 1 && dammyQuestion.type != 1000 && dammyQuestion.type != 10001 && dammyQuestion.type != 1 && dammyQuestion.type != 2 && dammyQuestion.parentAnswerId == null && dammyQuestion.parentQuestionId == null">
          <el-col class="mt-2" :span="24">
            <div class="custom-section-container">
              <div class="section-header" @click="packetSettingsDock = !packetSettingsDock">
                <div class="section-title">
                  <div class="section-head">
                    <label>{{ $t("components.registerForm.questionEdit.showOptions") }}</label>
                    <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                  </div>
                  <span>{{ $t("components.registerForm.questionEdit.showOptionsMsg") }}</span>
                </div>
                <div class="section-accordion">
                  <i class="fa" :class="packetSettingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </div>
              </div>
              <transition name="el-zoom-in-top">
                <div class="section-wrapper" v-show="packetSettingsDock">
                  <div class="custom-radio-table-title">
                    <div></div>
                    <div>{{ $t("components.registerForm.questionEdit.show") }}</div>
                    <div>{{ $t("components.registerForm.questionEdit.required") }}</div>
                    <div>{{ $t("components.registerForm.questionEdit.hide") }}</div>
                  </div>
                  <div class="custom-radio-table-title base" v-for="packet in dammyQuestion.packetLimitations" :key="packet.packetId + 'selectPacketd'">
                    <div>{{ currentForm.packets.find(x => x.id == packet.packetId).title }}</div>
                    <div>
                      <el-radio v-model="packet.type" :label="0">{{ $t("components.registerForm.questionEdit.show") }}</el-radio>
                    </div>
                    <div>
                      <el-radio v-model="packet.type" :label="1">{{ $t("components.registerForm.questionEdit.required") }}</el-radio>
                    </div>
                    <div>
                      <el-radio v-model="packet.type" :label="2">{{ $t("components.registerForm.questionEdit.hide") }}</el-radio>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-if="mainType == 1 && dammyQuestion.parentAnswerId == null && dammyQuestion.parentQuestionId == null">
          <el-col class="mt-2" :span="24">
            <div class="custom-section-container">
              <div class="section-header" @click="serviceSettingsDock = !serviceSettingsDock">
                <div class="section-title">
                  <div class="section-head">
                    <label>{{ $t("components.registerForm.questionEdit.showOptions") }}</label>
                    <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                  </div>
                  <span>{{ $t("components.registerForm.questionEdit.showOptionsMsg") }}</span>
                </div>
                <div class="section-accordion">
                  <i class="fa" :class="serviceSettingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                </div>
              </div>
              <transition name="el-zoom-in-top">
                <div class="section-wrapper" v-show="serviceSettingsDock">
                  <div class="custom-radio-table-title">
                    <div></div>
                    <div>{{ $t("components.registerForm.questionEdit.show") }}</div>
                    <div>{{ $t("components.registerForm.questionEdit.required") }}</div>
                    <div>{{ $t("components.registerForm.questionEdit.hide") }}</div>
                  </div>
                  <div class="custom-radio-table-title base" v-for="service in dammyQuestion.additionalServiceLimitations" :key="service.additionalServiceId + 'selectPacketd'">
                    <div>{{ currentForm.additionalServices.find(x => x.id == service.additionalServiceId).title }}</div>
                    <div>
                      <el-radio v-model="service.type" :label="0">{{ $t("components.registerForm.questionEdit.show") }}</el-radio>
                    </div>
                    <div>
                      <el-radio v-model="service.type" :label="1">{{ $t("components.registerForm.questionEdit.required") }}</el-radio>
                    </div>
                    <div>
                      <el-radio v-model="service.type" :label="2">{{ $t("components.registerForm.questionEdit.hide") }}</el-radio>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </el-col>
        </el-row>
      </template>
    </div>
    <div class="modal-footer" slot="footer" v-if="dammyQuestion">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("components.registerForm.questionEdit.close") }}</el-button>
        <template v-if="dammyQuestion.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("components.registerForm.questionEdit.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="saveEdit">{{ $t("components.registerForm.questionEdit.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import countryList from "../../helpers/countryList.json";
export default {
  props: ["mainType", "question"],
  data() {
    return {
      serviceSettingsDock: false,
      packetSettingsDock: false,
      imageAll: false,
      textAll: false,
      spreadSheetAll: false,
      presentationAll: false,
      compressedAll: false,
      isImageIndeterminate: true,
      isTextIndeterminate: true,
      isSpeadSheetTypeIndeterminate: true,
      isPresentationTypeIndeterminate: true,
      isCompressedTypeIndeterminate: true,
      dammyQuestion: null,
      countryList,
      colors: ["fb5779", "ffa800", "48dafd", "00d4c8"],
      typeList: ["ImageFileType", "TextFileType", "SpeadSheetType", "PresentationFileType", "CompressedFileType"]
    };
  },
  computed: {
    currentForm() {
      return this.$store.getters.getCurrentRegisterForm;
    },
    getQuestionValidationOne() {
      return this.$store.getters.getQuestionValidationOne;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },
  async created() {
    this.loadQuestion();
  },
  methods: {
    deleteItem() {
      this.$emit("deleteMe", this.dammyQuestion.id);
      this.$emit("closeDialog");
    },
    handleCheckAllImage(val) {
      if (val == true) {
        this.getEnums
          .find(x => x.title == "ImageFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data == -1) {
              this.dammyQuestion.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find(x => x.title == "ImageFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data != -1) {
              this.dammyQuestion.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isImageIndeterminate = false;
    },
    handleCheckAllText(val) {
      if (val == true) {
        this.getEnums
          .find(x => x.title == "TextFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data == -1) {
              this.dammyQuestion.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find(x => x.title == "TextFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data != -1) {
              this.dammyQuestion.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isTextIndeterminate = false;
    },
    handleCheckAllSpeadSheetType(val) {
      if (val == true) {
        this.getEnums
          .find(x => x.title == "SpeadSheetType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data == -1) {
              this.dammyQuestion.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find(x => x.title == "SpeadSheetType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data != -1) {
              this.dammyQuestion.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isSpeadSheetTypeIndeterminate = false;
    },
    handleCheckAllPresentationType(val) {
      if (val == true) {
        this.getEnums
          .find(x => x.title == "PresentationFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data == -1) {
              this.dammyQuestion.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find(x => x.title == "PresentationFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data != -1) {
              this.dammyQuestion.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isPresentationTypeIndeterminate = false;
    },
    handleCheckAllCompressedType(val) {
      if (val == true) {
        this.getEnums
          .find(x => x.title == "CompressedFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data == -1) {
              this.dammyQuestion.allowedExtensions.push(x.displayName);
            }
          });
      } else {
        this.getEnums
          .find(x => x.title == "CompressedFileType")
          .enums.map(x => {
            var data = this.dammyQuestion.allowedExtensions.findIndex(y => y == x.displayName);
            if (data != -1) {
              this.dammyQuestion.allowedExtensions.splice(data, 1);
            }
          });
      }
      this.isCompressedTypeIndeterminate = false;
    },
    loadQuestion() {
      this.$nextTick(() => {
        this.dammyQuestion = JSON.parse(JSON.stringify(this.question));
      });
      this.$nextTick(() => {
        if (this.mainType != 5 && this.dammyQuestion.parentAnswerId == null && this.dammyQuestion.parentQuestionId == null) {
          this.$nextTick(() => {
            this.dammyQuestion.packetLimitations = this.dammyQuestion.packetLimitations.filter(y => this.currentForm.packets.some(x => x.id == y.packetId));

            this.currentForm.packets.map(x => {
              var payload = {
                packetId: x.id,
                title: x.title,
                stock: x.stock
              };

              if (!this.dammyQuestion.packetLimitations.some(y => y.packetId == x.id)) {
                this.dammyQuestion.packetLimitations.push(payload);
              }
            });
          });
          this.$nextTick(() => {
            if (this.dammyQuestion.parentAnswerId == null && this.dammyQuestion.parentQuestionId == null) {
              this.currentForm.additionalServices.map(y => {
                var payload = {
                  additionalServiceId: y.id,
                  title: y.title,
                  type: null
                };
                if (!this.dammyQuestion.additionalServiceLimitations.some(c => c.additionalServiceId == y.id)) {
                  this.dammyQuestion.additionalServiceLimitations.push(payload);
                }
              });
            }
          });
        }
      });
    },
    async saveEdit() {
      var res = await this.$store.dispatch("saveQuestionOne", this.dammyQuestion);
      await this.$store.dispatch("getQuestionsObject", { type: this.dammyQuestion.mainType, id: this.dammyQuestion.registrationFormId });
      if (!res.data.alert.hasError) {
        this.$emit("saveEdit");
      }
    }
  },
  watch: {
    question: function() {
      this.loadQuestion();
    }
  }
};
</script>

<style lang="less" scoped>
.bottom {
  margin-top: 1rem;
  display: flex;
  padding: 20px;
  justify-content: flex-end;
  gap: 1rem;
}
#question-edit-dialog {
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      height: 120px;
      .el-icon-upload {
        font-size: 30px;
        margin: 0;
      }
    }
  }
}

.collapse-title-editing {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .el-switch {
    margin-right: 1rem;
  }
}
.custom-radio-table-title.base {
  .el-radio__label {
    display: none;
  }
}
.question-checkbox-container {
  display: flex;
  margin-bottom: 1rem;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  .el-checkbox {
    margin: 0;
  }
  & > .question-checkbox-title {
    display: flex;
    width: 200px;
    gap: 0.5rem;
    align-items: center;
    justify-content: flex-start;
  }
  & > .list-checkbox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 0.5rem;
    align-items: center;
  }
  .question-custom-checkbox-group {
    display: flex;
    gap: 0.5rem;
  }
}
.color-picker-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  .color {
    position: relative;
    width: 40px;
    height: 40px;
    color: white;
    border-radius: 50%;
    cursor: pointer;
    i {
      display: none;
    }
    &.active {
      i {
        position: absolute;
        font-size: 14px;
        top: calc(~"50% - 7px");
        left: calc(~"50% - 7px");
        font-weight: bold;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/QuestionEdit.vue